/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface ICalculateSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.CalculateWorkflowBlock;
        processConfigId: string;
        isReadonly: boolean;
        calculations: Wars.Domain.Model.Calculations.Calculation[];
        model: CalculateSettingsModel;
        calculationChanged(): void;
    }

    export class CalculateSettingsModalController extends BaseModalController {
        scope: ICalculateSettingsModalControllerScope;


        constructor(
            $scope: ICalculateSettingsModalControllerScope,
            workflowBlock: models.CalculateWorkflowBlock,
            processConfigId: string,
            isReadonly: boolean,
            calculationService: services.CalculationService,
            treeService: services.TreeService,
            schemaPropertyService: services.SchemaPropertyService,
            close: any) {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.isReadonly = isReadonly;
            this.scope.processConfigId = processConfigId;
            this.scope.model = new CalculateSettingsModel(treeService, schemaPropertyService, workflowBlock.calculateDto);
            this.scope.calculationChanged = () => this.scope.workflowBlock.componentId = this.scope.workflowBlock.calculateDto.calculationId;

            calculationService.getAllCalculations(processConfigId).then((calculations) => this.scope.calculations = calculations);
        }
    }

    export class CalculateSettingsModel {
        private schemaProperty: Wars.Domain.Model.SchemaProperty;

        constructor(
            private treeService: services.TreeService,
            private schemaPropertyService: services.SchemaPropertyService,
            private calculateDto: Wars.Domain.Model.Dtos.Workflow.CalculateDto) {
            if (calculateDto.resultSchemaPropertyId) {
                this.schemaPropertyService.getSchemaProperty(calculateDto.resultSchemaPropertyId).then((schemaProperty) => this.schemaProperty = schemaProperty);
            }
        }

        public onDragOver($event: any): void {
            //var treeConfig = this.treeService.getTreeConfigurationItem();
        }

        public onDrop($event: any): void {
            var treeConfig = this.treeService.getTreeConfigurationItem();

            this.calculateDto.resultSchemaPropertyId = treeConfig.schemaPropertyId;
            this.schemaPropertyService.getSchemaProperty(treeConfig.schemaPropertyId).then((schemaProperty) => this.schemaProperty = schemaProperty);

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
        }
    }
}

warsApp.registerController('CalculateSettingsModalController', ['$scope', 'workflowBlock', 'processConfigId', 'isReadonly', 'calculationService', 'treeService', 'schemaPropertyService', 'close']);